/* subscription scroll */

$(function() {
  return $('.scrollto').click(function() {
    return $('.subscrtiptionscroll')[0].scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});




/*============================================================================
  popup video
==============================================================================*/


"use strict";

(function(){

	function SthSelectPopup(properties){

		var self = this;
		var _$popup = null;
		var _$title = null;
		var _$titleText = null;
		var _$titleClose = null;
		var _$content = null;
		var _$filter = null;
		var _$overlay = null;
		var _properties = properties;
		var _onSelectCallback = null;
		var _qntityOfItems = 0;
		var _items = [];
		var _filteredItems = [];

		/**
		 * Max of height (in pixels) that the popup can
		 * assume when open.
		 */
		var MAX_HEIGHT = 500;

		/**
		 * Constructor.
		 * Creates the popup section element in the DOM.
		 *
		 * The section is created only once. Several calls
		 * does not have effect.
		 */
		(function create(){
			const isInDOM = isAlreadyInDOM();
			if( isInDOM ){
				_$popup = $(".sth-select-popup");
				_$title = $(".sth-select-title");
				_$titleText = $(".sth-select-title-text");
				_$titleClose = $(".sth-select-title-close");
				_$content = $(".sth-select-content");
				_$filter = $(".sth-select-filter");
				_$overlay = $(".sth-overlay");
			} else {
				_$popup = $('<section class="sth-select-popup"></section>');
				_$title = $('<div class="sth-select-title"></div>');
				_$titleText = $('<span class="sth-select-title-text"></span>');
				_$titleClose = $('<span class="sth-select-title-close">X</span>');
				_$content = $('<div class="sth-select-content"></div>');
				_$filter = $('<input class="sth-select-filter"/>');
				_$overlay = (new window.SthOverlay());

				_$title
					.append(_$titleText)
					.append(_$titleClose);

				_$popup
					.append(_$title)
					.append(_$filter)
					.append(_$content)
					.appendTo( $("body") );
			}

			if (isInDOM) {
				_$titleClose.click( e => {
					hide(e);
				});
			}

			_$filter.keydown(e => {
				setTimeout(_ => {
					_renderList(_properties.caseSensitive);
				}, 0);
			});

			_items = properties.items;
			_filteredItems = _items;
			_qntityOfItems = _items.length;
		})();

		/**
		 * Checks if the popup is already inserted in DOM.
		 * It prevents many insertions and performance loss.
		 */
		function isAlreadyInDOM(){
			let $alreadyExistent = $(".sth-select-popup");
			return ( $alreadyExistent && $alreadyExistent.length > 0 );
		}

		/**
		 * Shows the popup on the screen.
		 */
		function show(e){
			_$overlay.show();
			_properties.onOpen(e);

			if( ! _properties.hasFilter )
				_$filter.val("");

			_$titleText.text(_properties.title);
			_controlFilterVisibility();
			_renderList(_properties.caseSensitive);

			let height = _calculatePopupHeight();
			_$popup.animate({height: height}, 500);
		}

		/**
		 * Calculates pop-up's height based on
		 * number of added items.
		 */
		function _calculatePopupHeight(){
			let singleItemHeight = _$content
				.find(".sth-select-item")
				.first()
				.outerHeight();

			let qntityOfItems = _qntityOfItems;
			let allItemsHeight = (singleItemHeight * qntityOfItems);
			let titleHeight = _$title.outerHeight();

			let contentHeight = (allItemsHeight + titleHeight);
			return contentHeight < MAX_HEIGHT ? contentHeight : MAX_HEIGHT;
		}

		/**
		 * Hides the popup on the screen.
		 */
		function hide(e){
			_$overlay.hide();
			_properties.onHide(e);
			_$popup.animate({height: 0}, 500);
		}

		/**
		 * Add an item.
		 */
		function _addItem(item, autoRender){
			autoRender = autoRender || true;

			let text = item.text;
			let $listItem = $('<div class="sth-select-item">' + text + '</div>');
			$listItem.data('item', item);

			if( autoRender )
				_$content.append( $listItem );

			return $listItem;
		}

		/**
		 * Renders all elements in the list of options.
		 */
		function _renderList(caseSensitive){
			_clear();

			let rerenderOnEachItem = false;
			let $listItems = $([]);
			const textFilter = _formatText(caseSensitive, _$filter.val())

			_items.forEach( item => {
				const text = _formatText(caseSensitive, item.text)
				if(text.indexOf(textFilter) != -1){
					let $listItem = _addItem(item, rerenderOnEachItem);
					$listItems = $listItems.add( $listItem );
				}
			});

			_$content.append( $listItems );
			_$content.one('click', function (event) {
				const item = $(event.target).data('item')
				_properties.onSelect(item, event);
				_onSelectCallback( item );
				hide(event);
			});
			let popupHeight = _calculatePopupHeight();
			let titleHeight = _$title.outerHeight();
			_$content.outerHeight( (popupHeight - titleHeight) );
		}

		/**
		 * Clear (removes from DOM) all elements on the list.
		 */
		function _clear(){
			_$content.off('click');
			_$content.empty();
		}

		/**
		 * Event handler which calls a callback when an item
		 * is selected.
		 */
		function onSelect(callback){
			_onSelectCallback = callback;
		}

		/**
		 * Sets the filter field visibility based on
		 * hasFilter property.
		 */
		function _controlFilterVisibility(){
			let visibility = _properties.hasFilter ? "block" : "none";
			_$filter.css("display", visibility);
			_$filter.attr("placeholder", _properties.filterPlaceholder);
		}

		/**
		 * Returns text itself if caseSensitive is true
		 */
		function _formatText(caseSensitive, text) {
			return caseSensitive ? text : text.toLowerCase()
		}

		/**
		 * Public available methods.
		 */
		return {
			show: show,
			hide: hide,
			onSelect: onSelect
		};
	}

	window.SthSelect = window.SthSelect || {};
	window.SthSelect.SthSelectPopup = SthSelectPopup;
})();



$(function() {

  $("[data-media]").on("click", function(e) {
      e.preventDefault();
      var $this = $(this);
      var videoUrl = $this.attr("data-media");
      var popup = $this.attr("href");
      var $popupIframe = $(popup).find("iframe");

      $popupIframe.attr("src", videoUrl);

      $this.closest("body").addClass("show-popup");
  });

  $(".popup").on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      $("body").removeClass("show-popup");
      //var video = $("#media-popup iframe").attr('src');
      $("#media-popup iframe").attr('src', "");
      //$("#media-popup iframe").attr('src', video);
  });

  $(".popup > iframe").on("click", function(e) {
      e.stopPropagation();
  });

});  




/* end popup video */   




/* float cart button */  
jQuery(window).on('scroll', function () {
  if(jQuery('.add-to-cart__wrapper').length){
    var top = jQuery(window).scrollTop(),
        divBottom = jQuery('.shopify-product-form').offset().top + jQuery('.shopify-product-form').outerHeight();
    if (divBottom > top) {
      jQuery('.add-to-cart__wrapper').removeClass('cartfixed');
    } else {
      jQuery('.add-to-cart__wrapper').addClass('cartfixed');
    }
  }
});
/* end float cart button*/  


(function () {
  "use strict";

  var selector = ".lite-youtube, .lite-youtube-dev, lite-youtube";
  var loadingPromise = null;
  var retryLimit = 2;
  var loadTimeout = 10000;

  function containsVideo(root) {
    return Boolean(
      (root.matches && root.matches(selector)) ||
        (root.querySelector && root.querySelector(selector)),
    );
  }

  function loadPlayer(attempt) {
    if (window.LiteYTEmbedDiv && window.LiteYTEmbedDiv.init) {
      return Promise.resolve();
    }
    if (loadingPromise) return loadingPromise;

    var script = document.createElement("script");
    var scriptUrl = new URL(window.theme.assets.liteYoutube, document.baseURI);
    if (attempt) scriptUrl.searchParams.set("lite_youtube_retry", String(attempt));
    script.type = "module";
    script.src = scriptUrl.href;
    script.dataset.liteYoutubeLoader = "true";

    var request = new Promise(function (resolve, reject) {
      var timer;
      function cleanup() {
        window.clearTimeout(timer);
        script.removeEventListener("load", onLoad);
        script.removeEventListener("error", onError);
      }
      function onLoad() {
        cleanup();
        resolve();
      }
      function onError() {
        cleanup();
        reject(new Error("Failed to load " + script.src));
      }

      script.addEventListener("load", onLoad);
      script.addEventListener("error", onError);
      timer = window.setTimeout(function () {
        cleanup();
        reject(new Error("Timed out loading " + script.src));
      }, loadTimeout);
    }).then(function () {
      if (!window.LiteYTEmbedDiv || !window.LiteYTEmbedDiv.init) {
        throw new Error("lite-youtube.js loaded without initializing LiteYTEmbedDiv");
      }
    });

    var promise = request.catch(function (error) {
      script.remove();
      if (attempt >= retryLimit) {
        if (loadingPromise === promise) loadingPromise = null;
        throw error;
      }

      return new Promise(function (resolve) {
        window.setTimeout(resolve, 250 * (attempt + 1));
      }).then(function () {
        if (loadingPromise === promise) loadingPromise = null;
        return loadPlayer(attempt + 1);
      });
    });

    loadingPromise = promise;
    document.head.appendChild(script);
    return promise;
  }

  function initialize(root) {
    if (!containsVideo(root)) return Promise.resolve();

    if (window.LiteYTEmbedDiv) {
      window.LiteYTEmbedDiv.init(root);
      return Promise.resolve();
    }
    if (!window.theme || !window.theme.assets || !window.theme.assets.liteYoutube) {
      return Promise.resolve();
    }

    return loadPlayer(0).then(function () {
      if (window.LiteYTEmbedDiv) window.LiteYTEmbedDiv.init(root);
    });
  }

  function initializeSafely(root) {
    initialize(root).catch(function (error) {
      console.error(error);
    });
  }

  initializeSafely(document);
  document.addEventListener("shopify:section:load", function (event) {
    initializeSafely(event.target);
  });

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE && containsVideo(node)) {
          initializeSafely(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  "use strict";

  function secureBlankTargetLinks(root) {
    var links = [];
    if (root.matches && root.matches('a[target="_blank"]')) links.push(root);
    if (root.querySelectorAll) {
      links.push.apply(links, root.querySelectorAll('a[target="_blank"]'));
    }

    links.forEach(function (link) {
      var rel = new Set((link.getAttribute("rel") || "").split(/\s+/).filter(Boolean));
      rel.add("noopener");
      link.setAttribute("rel", Array.from(rel).join(" "));
    });
  }

  secureBlankTargetLinks(document);
  document.addEventListener("shopify:section:load", function (event) {
    secureBlankTargetLinks(event.target);
  });

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) secureBlankTargetLinks(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();










